<template>
  <div>
    <a @click.stop.prevent="onClick">
      <forward-icon height="75" icon-name="Next Activity" width="75"></forward-icon>
    </a>
  </div>
</template>

<script>
import ForwardIcon from 'components/icons/ForwardIcon.vue';

export default {
  props: {
    onClick: {
      type: Function,
      default: () => {},
      required: true
    }
  },
  components: {
    ForwardIcon
  }
};
</script>
